<template>
  <div>
    <div class="transition-wrapper justify-center items-center ">
      <div class="w-3/4 md:w-1/4 flute">
        <svg xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg"
          xmlns:cc="http://web.resource.org/cc/" xmlns:dc="http://purl.org/dc/elements/1.1/"
          xmlns:svg="http://www.w3.org/2000/svg" id="svg2" viewBox="0 0 552.71 578.744" version="1.0">
          <g id="g2772" fill-rule="evenodd">
            <path id="path9" fill="#000"
              d="m202.06 326.81c9.12 0 16.53 7.41 16.53 16.53s-7.41 16.52-16.53 16.52-16.52-7.4-16.52-16.52 7.4-16.53 16.52-16.53" />
            <path id="path11" stroke="#fff" stroke-width="1" stroke-miterlimit="10"
              d="m0.02 553.56c0.432-1.15 1.08-2.05 1.8-2.7 0.756-0.69 1.656-1.33 2.7-1.55 0.936-0.32 1.692-0.39 2.664-0.22l34.92-36.93-2.916-2.92c-1.692 0.22-3.06 0.07-4.248-0.43-1.296-0.54-2.196-0.97-2.7-2.7-0.648-1.84-1.692-4.93-0.216-8.03 1.512-3.24 4.896-8.17 9.18-10.76 4.104-2.77 12.096-5.33 15.66-4.9 3.564 0.47 5.22 3.02 5.364 7.82l16.776-14.76-2.016-3.57c-3.24 0.79-5.652 0.47-7.38-0.97-1.836-1.55-3.492-4.57-2.88-7.81 0.648-3.39 3.204-8.39 6.696-11.67 3.348-3.38 10.044-6.91 13.86-7.81 3.708-0.9 6.948 0.83 8.748 2.66 1.836 1.77 2.412 4.5 2.016 8.07l8.932-9.4c-3.24-0.9-5.66-1.94-7.384-3.13-1.8-1.19-3.276-2.67-2.916-4.03 0.396-1.41 1.908-3.1 4.93-4.68-1.942-1.62-3.058-3.32-3.346-4.94-0.36-1.72-0.54-2.7 1.548-5.14 2.128-2.56 7.958-8.32 10.978-10.08 2.88-1.84 5.04-2.13 6.48-0.87-1.15-2.59-1.51-4.93-0.68-6.73 0.79-1.83 3.02-3.42 5.15-4.46 1.98-1.19 3.92-2.81 6.94-2.23 2.96 0.47 6.66 2.3 10.98 5.36l3.35-3.81-6.95-5.8c-1.98-0.76-3.13-1.66-3.6-2.7-0.61-1.23-0.43-2.77 0.69-3.82 1.04-1 2.99-1.62 5.83-1.98l2.88-2.26c-1.19-1.05-1.66-1.88-1.55-2.88 0.07-1.05 1.05-2.2 2.23-2.92 1.16-0.83 2.6-1.22 4.47-1.58l11.88-11.42c-0.69-1.51-0.94-2.8-0.9-4.03-0.07-1.22 0.25-2.59 1.11-3.13 0.8-0.69 2.24-0.9 4.04-0.65l6.69-6.48c0.4-1.69 1.12-2.84 2.02-3.6 0.9-0.79 1.98-1.04 3.38-0.9l19.66-17.89c-0.18-1.94 0.25-3.38 1.15-4.46s2.27-1.8 4.25-2.02l84.09-87.34c13.22-13.39 24.81-24.87 35.36-35.28 10.47-10.33 19.44-19.08 27.32-26.38-0.5-2.42-0.29-3.96 0.65-4.94 0.86-0.9 2.48-1.22 4.71-0.68l5.37-4.9c-0.72-2.48-0.51-4.1 0.65-5.14 1.08-0.98 3.09-1.37 6.04-0.9 1.91-3.14 3.42-4.76 4.94-5.15 1.33-0.47 3.16 1.8 3.56 2.91 0.4 1.05-0.14 2.24-1.33 3.57l7.16 5.15 17.25-17.25c0.07-1.65 0.28-3.02 0.64-4.25 0.29-1.33 0.15-2.37 1.37-3.13 1.19-0.75 2.95-1.08 5.58-1.11l19.69-21.24c-0.65-1.55-0.5-2.88 0.43-4.14 0.94-1.37 3.28-2.81 4.94-3.35 1.55-0.58 2.91-0.58 4.24 0l53.03-53.931c-1.08-0.36-1.87-0.828-2.23-1.8-0.54-0.9-2.23-1.188-0.22-3.78 2.02-2.736 7.96-8.352 12.28-12.564 4.25-4.392 8.86-10.332 13-12.96 3.99-2.556 7.59-3.42 10.94-2.448l14.33-15.049c-0.4-0.972-0.14-1.872 0.47-2.7 0.61-0.9 1.73-2.088 3.35-2.448 1.62-0.468 3.88-0.792 6.26 0 2.34 0.648 5.87 1.368 7.38 4.248 1.33 2.808 1.51 7.056 0.69 12.744l-93.53 98.678-9.18 9.83c0.47 2.16-0.11 3.81-1.34 5.36-1.26 1.48-3.56 2.56-6.51 3.38l-18.79 20.34c0.43 1.59 0.14 3.03-0.87 4.47-1.11 1.47-4.21 3.27-5.4 4.03-1.26 0.61-1.8 0.54-1.76-0.22l-110.31 116.68c-0.28 2.16-0.79 4.03-1.8 5.62-0.97 1.54-1.94 2.66-4.03 3.78-2.23 1-5.29 1.83-9.18 2.48 0.83 2.34 2.38 3.27 4.5 3.35 2.05-0.15 5.51-3.24 8.28-3.6 2.77-0.43 6.3-0.07 8.5 1.36 2.23 1.45 5.11 4.76 4.46 7.17-0.83 2.38-5.65 5.58-9.18 6.7-3.74 0.86-8.82 0.46-12.31-0.9-3.42-1.34-6.23-3.93-8.28-7.39 0.58 4.94 0 8.79-1.33 11.42-1.44 2.55-5.08 3.67-7.17 4.46-2.19 0.72-3.96 0.9-5.58 0.25l-105.15 111.24c1.08 3.24 0.93 5.58-0.43 7.17-1.44 1.54-3.96 2.34-7.85 2.23 1.04 4.28 1.19 8.06 0.43 11.63-0.86 3.52-3.17 6.66-5.11 9.39-1.98 2.67-3.78 5.4-6.52 6.27-2.84 0.68-6.23 0.18-10.29-1.8l-105.81 111.67c0.218 1.01-0.178 1.98-0.898 3.06-0.756 1.01-2.124 2.05-3.816 3.13-6.228-3.63-11.268-7.38-15.66-11.63-4.357-4.24-7.74-8.71-10.296-13.53z" />
            <path id="path91"
              d="m191.76 344.36c2.44 2.88 4.39 4.54 6.12 4.82 1.65 0.26 2.91-0.71 3.92-3.05l-6.08-6.56c-1.3 1.59-2.63 3.17-3.96 4.79z"
              stroke="#fff" stroke-miterlimit="10" stroke-width=".036" fill="#000" />
            <path id="path95"
              d="m176.92 356.82l-4.57 4.82 1.3 4.79c0.5-1.84 1.08-3.38 1.73-4.79 0.64-1.48 1.26-2.52 1.98-3.53-0.15-0.43-0.29-0.86-0.44-1.29z"
              stroke="#fff" stroke-miterlimit="10" stroke-width=".036" fill="#000" />
            <path id="path97"
              d="m161.19 372.12l-6.98 6.77 2.63 3.49c1.51-0.9 2.98-1.37 4.57-1.55 1.58-0.18 2.99 0.03 4.61 0.65-2.2-1.12-3.53-2.38-4.4-3.93-0.82-1.62-0.97-3.38-0.43-5.43z"
              stroke="#fff" stroke-miterlimit="10" stroke-width=".036" fill="#000" />
            <path id="path99"
              d="m147.22 387.6c-3.06 1.37-4.6 2.77-4.78 4.6-0.18 1.77 3.2 4 3.92 5.87 0.65 1.8 0.72 3.21 0.22 4.61l3.49 5.44 2.63-3.06c-2.09-3.03-3.46-5.51-3.96-7.85-0.51-2.41 0.64-4.43 0.68-5.9-0.14-1.52-0.54-2.45-1.33-2.81l-0.87-0.9z"
              stroke="#fff" stroke-miterlimit="10" stroke-width=".036" fill="#000" />
            <path id="path107"
              d="m217.32 315.56l-8.07 8.71 4.36 2.85c2.3-0.32 4.39-0.47 6.12-0.43 1.76 0.03 3.17 0.25 4.35 0.64l5.26-5.43c-2.84-0.15-5-0.22-6.34-0.22-1.36-0.18-1-0.36-1.98 0-1.08 0.4-2.48 1.19-4.35 2.38-1.8 0.14-2.34-0.22-1.77-1.08 0.54-0.94 2.34-2.34 5.26-4.36-0.94-1.01-1.87-2.02-2.84-3.06z"
              stroke="#fff" stroke-miterlimit="10" stroke-width=".036" fill="#000" />
            <path id="path179"
              d="m252.09 290.76l-9.32 10.55c4.07-0.33 7.31 0.07 9.86 1.19 2.45 1.15 4.36 2.87 5.33 5.47-1.12-3.03-1.87-5.51-2.12-7.85-0.33-2.34-0.15-4.25 0.39-5.87-1.37-1.15-2.73-2.31-4.14-3.49z"
              stroke="#fff" stroke-miterlimit="10" stroke-width=".036" fill="#000" />
            <path id="path181"
              d="m259.18 281.04l13.72-13.5 3.2 2.55c-1.26 2.49-1.87 4.4-2.12 5.87-0.29 1.48 0.07 2.23 0.79 2.67l-7.05 1.87 0.54 5.07c-1.16-0.18-2.24-0.18-3.1-0.14-0.94 0-1.73 0.18-2.38 0.4-1.18-1.59-2.37-3.17-3.6-4.79z"
              stroke="#fff" stroke-miterlimit="10" stroke-width=".036" fill="#000" />
            <path id="path183"
              d="m276.93 254.9l5.87-5.87 7.6 6.02c-0.33 1.11-0.33 2.41-0.15 3.88 0.18 1.48 0.54 3.03 1.23 4.79-0.47-0.39-1.55-0.75-2.96-0.93-1.44-0.22-3.49-0.4-5.86-0.4-1.91-2.48-3.82-4.97-5.73-7.49z"
              stroke="#fff" stroke-miterlimit="10" stroke-width=".036" fill="#000" />
            <path id="path185"
              d="m290 240.79l11.74-10.55 5.18 4.54c-0.32 0.97-0.5 2.12-0.4 3.45 0.04 1.34 0.22 2.7 0.69 4.4-2.16-0.33-4.25-0.51-6.41-0.26-2.16 0.11-4.39 0.65-6.55 1.34-1.41-0.98-2.81-1.95-4.25-2.92z"
              stroke="#fff" stroke-miterlimit="10" stroke-width=".036" fill="#000" />
            <path id="path187" d="m322.15 207.63l7.59-7.48 5.62 6.26-6.7 6.26-6.51-5.04z" stroke="#fff"
              stroke-miterlimit="10" stroke-width=".036" fill="#000" />
            <path id="path189" d="m332.95 197.73l9.61-8.92 5.07 4.93-9.75 9.21-4.93-5.22z" stroke="#fff"
              stroke-miterlimit="10" stroke-width=".036" fill="#000" />
            <path id="path191"
              d="m358.04 175.74c2.09 1.76 3.46 2.91 4.25 3.45 0.61 0.44-0.69 0.26 0.14-0.39 0.83-0.72 2.38-2.05 4.79-3.85l-5.33-3.75c-1.26 1.51-2.55 3.03-3.85 4.54z"
              stroke="#fff" stroke-miterlimit="10" stroke-width=".036" fill="#000" />
            <path id="path193" d="m368.3 165.08l3.6-3.89 4 3.6-5.08 5.08-3.06-3.46 0.54-1.33z" stroke="#fff"
              stroke-miterlimit="10" stroke-width=".036" fill="#000" />
            <path id="path197"
              d="m327.87 216.31c-1.26-1.3-2.41-2.63-3.74-3.85-1.33-1.26-2.67-2.56-4.14-3.75l-1.73 1.88 8.96 8.92c-0.03-0.61 0-1 0.11-1.58s0.29-1.12 0.54-1.62z"
              stroke="#fff" stroke-miterlimit="10" stroke-width=".036" fill="#000" />
            <path id="path199"
              d="m311.35 222.07l7.59-7.2 8.14 9.07c-0.68-0.21-2.2-0.39-4.54-0.14-2.37 0.14-5.58 0.54-9.61 1.19-0.5-0.98-1.04-1.95-1.58-2.92z"
              stroke="#fff" stroke-miterlimit="10" stroke-width=".036" fill="#000" />
            <path id="path201" d="m350.3 179.59l5.47 4h5.19l1.33-1.73-7.35-6.3-4.64 4.03z" stroke="#fff"
              stroke-miterlimit="10" stroke-width=".036" fill="#000" />
          </g>
        </svg>
      </div>

    </div>
    <div class="antialiased bg-body text-body font-body  relative">

      <top></top>
      <div>
        <router-view></router-view>
      </div>
      <bottom></bottom>

    </div>



  </div>
</template>
<script>
// @ is an alias to /src
import Top from './components/Top.vue';
import Bottom from './components/Bottom.vue';
import gsap from "gsap"
import { useHead } from '@vueuse/head'



export default {
  name: 'HomeView',
  components: {
    Top,
    Bottom
  },

  watch: {
    '$route'(to, from) {
      if (to.name != from.name) {
        var tl = new gsap.timeline();
        tl.to('.transition-wrapper', 0, { display: 'flex' });
        tl.to('.transition-wrapper', 0, { opacity: 1 });
        tl.to('.flute', 1, { opacity: 0.9 });
        tl.to('.flute', 1, { opacity: 0 });
        tl.to('.transition-wrapper', 2, { opacity: 0 }, '-=0.8');
        tl.to('.transition-wrapper', 0, { display: 'none' });
        document.querySelector('html').style.overflow = 'initial';
      }

    }
  },

  beforeCreate() {
    useHead({
      title: 'Lucija Stilinović - ' + this.$t("header"),
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: 'Lucija Stilinović - ' + this.$t("header")
        },
        {
          hid: 'description',
          name: 'description',
          content: this.$t("biography.general.description")
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.$t("biography.general.description")
        },
        { hid: 'og:type', property: 'og:type', content: 'website' },
        { hid: 'og:url', property: 'og:url', content: `https://lucijastilinovic.com/` },
        { hid: 'og:image', property: 'og:image', content: '/share.jpeg' }
      ]
    })
  }
}
</script>
<style>
@tailwind base;
@tailwind components;
@tailwind utilities;
@import url("./assets/css/main.css");
@import url('https://fonts.googleapis.com/css2?family=Allura&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
</style>
<style lang="css">
.slide-enter-active,
.slide-leave-active {
  transition: opacity 1s transform 1s;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
  transform: translate(-30%);
}
</style>

